function getStartOfWeek(locale: string): 0 | undefined {
  const locales: Record<string, Record<string, 0>> = {
    fr: {
      'fr-CA': 0,
    },
  }

  return locales?.[locale]?.[window.navigator.language]
}

export default getStartOfWeek
